import {oneOf} from 'shared/store';
import { observable, override, makeObservable } from 'mobx';
import QUESTION_TYPES from './questionTypes';
import SECTION_TYPES from './sectionTypes';
import QAQuestion from '../questions/QAQuestion';
class PerformanceReviewQuestion extends QAQuestion {
  id;
  name;
  description;
  lexicalState;
  _relations = {
    questionType: oneOf(QUESTION_TYPES + SECTION_TYPES)
  };

  constructor(other) {
    super();

    this.required = true;

    makeObservable(this, {
      id: observable,
      name: observable,
      description: observable,
      lexicalState: observable,
      updateText: override,
      questionName: override
    });

    this.merge(other);
  }

  updateText(value) {
    this.merge({name: value});
  }

  get questionName() {
    return this.name;
  }
}

export default PerformanceReviewQuestion;
